import { Desktop } from 'styles/MediaQueries';
import { useNavigate } from 'react-router-dom';
import LeadIntroLogos from 'registration/lead/intro/LeadIntroLogos';
import MainLayout from 'components/component_lib/MainLayout';
import MillionCustomers from 'images/MillionCustomers.svg';
import React, { useEffect } from 'react';
import SiteHeader from '@opploans/site-header-component/SiteHeader';
import ThreeDots from 'images/ContainerIcons/ThreeDots.svg';
import TimedProgressBar from 'components/component_lib/TimedProgressBar';
import TrustPilotWidget from 'components/component_lib/TrustPilotWidget';

const logoContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  margin: '1.25rem 0',
  width: '100%',

  [Desktop]: {
    marginTop: 0
  }
};

const headerStyle = {
  fontSize: '1.5rem',
  fontWeight: 700,
  lineHeight: '1.75rem',
  margin: '1.25rem 1rem 0',
  textAlign: 'center'
};

const subtextStyle = {
  fontSize: '1rem',
  fontWeight: 400,
  lineHeight: '1.125',
  margin: '1.125rem 1rem 0',
  maxWidth: '16rem',
  textAlign: 'center'
};

const progressBarStyle = {
  margin: '3rem 2rem 0',
  width: '100%',
  maxWidth: '20rem'
};

const mainLayoutStyle = {
  minHeight: '40.5rem'
};

function HeaderText({ partnerName, showCobranding }) {
  return (
    <>
      {showCobranding && (
        <h1 css={headerStyle}>{partnerName} is connecting you to Opploans</h1>
      )}

      {!showCobranding && (
        <h1 css={headerStyle}>
          You are being connected to OppLoans&apos; secure application.
        </h1>
      )}
    </>
  );
}

function LeadIntroLoadingPage({
  partnerId = null,
  partnerName = null,
  showCobranding = false
}) {
  const navigate = useNavigate();

  useEffect(() => {
    window.setTimeout(() => {
      navigate('/register/lead_gate');
    }, 6500);
  }, []);

  return (
    <>
      <SiteHeader />

      <MainLayout icon={<ThreeDots />} additionalContentStyle={mainLayoutStyle}>
        <div css={logoContainerStyle}>
          <LeadIntroLogos
            partnerId={partnerId}
            partnerName={partnerName}
            showCobranding={showCobranding}
          />
        </div>

        <HeaderText partnerName={partnerName} showCobranding={showCobranding} />

        <p css={subtextStyle}>
          Applying with OppLoans does NOT affect your FICO credit score
        </p>

        <div css={progressBarStyle}>
          <TimedProgressBar seconds={6} />
        </div>

        <MillionCustomers css={{ marginTop: '2rem' }} />

        <TrustPilotWidget />
      </MainLayout>
    </>
  );
}

export default LeadIntroLoadingPage;
